import { render, staticRenderFns } from "./wellcome-dialog.vue?vue&type=template&id=d41cb118"
import script from "./wellcome-dialog.vue?vue&type=script&lang=js"
export * from "./wellcome-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports